export const getLanguage = (store) => store.language.selectedLanguage;
export const getLanguageNumber = (store) =>
  store.language.selectedLanguageNumber || 1;
